import { IconButton } from '@/components';
import type { FC, MouseEventHandler } from 'react';

export const Closer: FC<{ onClick: MouseEventHandler<HTMLButtonElement> }> = (
  props,
) => {
  // props
  const { onClick } = props;
  return (
    <IconButton
      circle
      title="关闭"
      className="absolute right-4"
      iconType="icon-a-guanbixiao"
      onClick={onClick}
    />
  );
};
